export type JsonLdValue = {
	[key: string]: unknown;
};

function safeJsonLd(value: JsonLdValue): string {
	return JSON.stringify(value)
		.replace(/</g, "\\u003c")
		.replace(/>/g, "\\u003e")
		.replace(/&/g, "\\u0026");
}

export function JsonLdScript({ value }: { value: JsonLdValue }) {
	return <script type="application/ld+json">{safeJsonLd(value)}</script>;
}
